import moment from 'moment'
import request from '@/utils/request'
import { excel2Json } from '@/utils/excel'

export function parseJinJiangReconciliationOrders(excelData) {
  const seen = new Set()
  const orders = excelData.map((row, index) => {
    const rawId = row['系统订单号']
    const id = rawId == null ? '' : String(rawId).trim()
    const amount = row['供应商支付成本']
    const rowLabel = `第 ${index + 2} 行`
    if (!id) throw new Error(`${rowLabel}系统订单号不能为空`)
    if (typeof rawId === 'number' && !Number.isSafeInteger(rawId)) {
      throw new Error(`${rowLabel}系统订单号过长，请在 Excel 中按文本保存后重新导入`)
    }
    if (seen.has(id)) throw new Error(`${rowLabel}系统订单号重复：${id}`)
    if (amount == null || !/^[+-]?(?:[0-9]+(?:\.[0-9]*)?|\.[0-9]+)$/.test(String(amount)) || !Number.isFinite(Number(amount))) {
      throw new Error(`${rowLabel}供应商支付成本必须为有效金额`)
    }
    seen.add(id)
    return { system_order_no: id, total_rate: amount }
  })
  if (!orders.length) throw new Error('数据不能为空')
  return orders
}

export default {
  data() {
    return {
      importParsing: false,
      importSubmitting: false,
      importPreviewPage: 1,
      importPreviewPageSize: 50,
    }
  },
  computed: {
    importBusy() {
      return this.importParsing || this.importSubmitting
    },
    importPreviewRows() {
      const start = (this.importPreviewPage - 1) * this.importPreviewPageSize
      return this.addLogform.jin_jiang_orders.slice(start, start + this.importPreviewPageSize)
    },
  },
  methods: {
    async postaddLog() {
      if (this.importBusy) return
      if (!this.addLogform.end_travel_date_start_at || !this.addLogform.end_travel_date_end_at) {
        this.$message.warning('请选择开始与结束日期')
        return
      }
      if (!this.addLogform.jin_jiang_orders.length) {
        this.$message.warning('请先导入订单对账文件')
        return
      }
      this.importSubmitting = true
      try {
        const response = await request({
          url: '/api/backend/reconciliation-log/create-log',
          method: 'POST',
          timeout: 600000,
          data: {
            jin_jiang_orders: this.addLogform.jin_jiang_orders,
            end_travel_date_start_at: moment(this.addLogform.end_travel_date_start_at).format('YYYY-MM-DD 00:00:00'),
            end_travel_date_end_at: moment(this.addLogform.end_travel_date_end_at).format('YYYY-MM-DD 23:59:59'),
          },
        })
        if (response.code === 0) {
          this.$message({ type: 'success', message: '对账完成' })
          this.showaddLog = false
          if (typeof this.fetchReconciliationDetail === 'function') {
            this.fetchReconciliationDetail(response.data.reconciliation_log_id)
          } else {
            this.getList()
          }
        }
        return response
      } catch (error) {
        // 普通请求异常由公共拦截器显示；超时不能据此认定后台没有保存。
        if (error && error.code === 'ECONNABORTED') {
          this.$message.warning('请求超时，请先到对账记录确认结果，避免重复提交')
        }
        return null
      } finally {
        this.importSubmitting = false
      }
    },
    async handleImportUsers(uploadFile) {
      if (this.importBusy) return
      const file = uploadFile.raw
      if (!file || !/\.(xlsx|xls)$/i.test(file.name)) {
        this.addLogform.jin_jiang_orders = []
        this.$message.error('上传文件格式不正确，请检查选择的文件')
        return
      }
      this.importParsing = true
      this.addLogform.jin_jiang_orders = []
      this.importPreviewPage = 1
      try {
        await this.$nextTick()
        const excelData = await excel2Json(file, 1)
        this.addLogform.jin_jiang_orders = parseJinJiangReconciliationOrders(excelData)
      } catch (error) {
        this.$message.error(error.message || '文件解析失败，请检查表头和数据格式')
      } finally {
        this.importParsing = false
      }
    },
  },
}
